//https://github.com/styled-components/styled-theming
// @ts-nocheck

import {
  FlattenInterpolation,
  ThemedStyledProps,
  ThemeProps,
} from 'styled-components';
/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type ThemeValueResult =
  | string
  | FlattenInterpolation<ThemeProps<any>>
  | FlattenInterpolation<ThemedStyledProps<any, any>>;
type ThemeValueFn = (props: object) => ThemeValueResult;
type ThemeValue = ThemeValueFn | ThemeValueResult;

interface ThemeMap {
  [key: string]: ThemeValue;
}

type VariantMap<TVariant extends string> = {
  [key in TVariant]: ThemeMap;
};

type ThemeSet = (props: object) => string;
export type VariantSet<
  TProp extends string,
  TVariant extends string,
> = (props: {
  [key in TProp]?: TVariant;
}) => string;

/* -------------------------------------------------------------------------------------------------
 * functions
 * -----------------------------------------------------------------------------------------------*/

function getThemeValue(name: string, props: any, values: any) {
  const value = props.theme && props.theme[name];

  let themeValue;

  if (typeof value === 'function') {
    themeValue = value(values);
  } else {
    themeValue = values[value];
  }

  if (typeof themeValue === 'function') {
    return themeValue(props);
  } else {
    return themeValue;
  }
}

function theme(name: string, values: ThemeMap): ThemeSet {
  return function (props) {
    return getThemeValue(name, props, values);
  };
}

function vendorTheme(values: ThemeMap): ThemeSet {
  return theme('vendor', values);
}

function themeVariants<TProp extends string, TVariant extends string>(
  name: string,
  prop: TProp,
  values: VariantMap<TVariant>,
): VariantSet<TProp, TVariant> {
  return function (props) {
    const variant = props[prop] && values[props[prop]];
    return variant && getThemeValue(name, props, variant);
  };
}

export { theme, themeVariants, vendorTheme };
